const formatPriceHelper = (value, currency) => {

  if (!currency) {
    return value ? value.toString() : '0';
  }
  
  return (
    new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: currency,
    }).format(value) +
    ' ' +
    currency
  );
};

export default formatPriceHelper;
